import React, { Component } from 'react';
import { message, Modal, Row, Table } from 'antd';
import { connect } from 'react-redux';

import moment from 'moment';
import { queryAllotApplyContract, queryContractList } from '@api/xxcrm/contract';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.loadDate();
  }

  findContractType = id => {
    const { list } = this.props;
    const type = list.map(item => {
      if (parseInt(item.value, 10) === parseInt(id, 10)) {
        return item.key;
      }
      return type;
    });
    for (let i = 0; i < list.length; i++) {
      if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
        return list[i].key;
      }
    }
    return type;
  };

  loadDate = (limit, type) => {
    const params = {};
    const context = this;
    params.start = 0;
    params.type = type || '';
    params.status = 0;
    params.limit = 10;
    queryContractList(params).then(res => {
      const selectedRowKeys = [];
      if (res.statusCode === 200) {
        res.data.map(item => {
          item.type = this.findContractType(item.type);
          selectedRowKeys.push(item.uuid);
          return selectedRowKeys;
        });
        context.setState({
          data: res.data,
          total: res.totalSize,
          selectedRowKeys,
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'no',
        key: 'no',
      },
      {
        title: '步骤',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          let status = '';
          if (text === 0) {
            status = '未使用';
          } else if (text === 1) {
            status = '已使用';
          } else if (text === 2) {
            status = '遗失';
          } else if (text === 3) {
            status = '作废';
          } else if (text === 4) {
            status = '已分配';
          } else if (text === 5) {
            status = '待审核';
          }
          return <span>{status}</span>;
        },
      },
      {
        title: '执行角色',
        dataIndex: 'type',
        key: 'type',
        render: text => {
          // let type = this.find_contract_type(text)
          return <span>{text}</span>;
        },
      },
      {
        title: '审核人',
        dataIndex: 'cdate',
        key: 'cdate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '审核时间',
        dataIndex: 'maturityDate',
        key: 'maturityDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '停留',
        dataIndex: 'allocateDate',
        key: 'allocateDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'allocateDate1',
        key: 'allocateDate1',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '审核备注',
        dataIndex: 'allocateDate2',
        key: 'allocateDate2',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
    ];
  };

  onSelectChange = selectedRowKeys => {
    this.setState({
      selectedRowKeys,
    });
  };

  submit = () => {
    const { record, cancel, loadDate } = this.props;
    const data = {};
    data.uuid = record.uuid;
    data.contractUuids = this.state.selectedRowKeys;
    if (data.contractUuids < 1) {
      message.error('暂时没有可分配的合同！');
      return;
    }
    queryAllotApplyContract(data).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        cancel();
        loadDate();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { data } = this.state;
    return (
      <Modal
        title="步骤"
        width={800}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
        footer={false}
      >
        <Row>
          <Table
            columns={this.columns()}
            dataSource={data}
            pagination={false}
            bordered
            rowKey="uuid"
          />
        </Row>
      </Modal>
    );
  }
}
export default connect(state => ({ list: state.contract_type }))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ModalStep.js